module.exports = __webpack_public_path__ + "static/media/logo2.bc15a02e.png";